import Layout from 'Nori/Layout';
import HeroFull from 'Nori/Hero/HeroFull';
import RichText from 'Custom/RichText';
import styles from 'styles/pages/whatToExpect.module.scss';
import Button from 'Nori/Button';
import QuestionWrapper from 'Custom/Question/QuestionsWrapper';
import Question from 'Custom/Question/index';
import Container from 'Nori/Container';
import { AlternativeTable } from 'Custom/Table/AlternativeTable';
import { SE_TABLE_3 } from 'Utils/side-effects';
import ItemBreakpoint from 'Custom/ItemBreakpoint/index';
import HERO_BG_IMAGE from 'Images/background/half-pink-marble.png';
import HERO_BG_IMAGE_MOBILE from 'Images/background/half-pink-marble-mobile.png';
import DownloadIcon from 'Images/brand-icons/download-file.svg';

import {
  FAQ_WTE_INSERTION_1,
  WTE_PERIOD,
  WTE_SIDE_EFFECTS,
  CALL_HCP_QUESTION,
} from 'Utils/what-to-expect';

const HEAD = {
  title:
    'What to Expect With NEXPLANON® (etonogestrel implant) 68 mg Radiopaque',
  description:
    'Learn what to expect after NEXPLANON® (etonogestrel implant) 68 mg Radiopaque insertion, including common side effects and when to call your doctor.',
  keywords: 'What to Expect with Nexplanon, Nexplanon Insertion',
};

const HeroBannerContent = () => {
  return (
    <div className={styles['content-wrap']} data-qa-tag="hero-content">
      <RichText data-qa-tag="hero-text">
        <div className={styles.wtePage} data-qa-tag="what-to-expect-hero">
          <h4 data-qa-tag="hero-title">WHAT TO EXPECT</h4>
          <p className={styles.middleHeroText} data-qa-tag="hero-subtitle">
            What to expect after your
            <br />
            insertion procedure
          </p>
          <Button
            href="/assets/static/What-to-Expect-Guide-Refreshed-2025.pdf"
            target="_blank"
            rel="noopener"
            data-design-type="clickAction"
            data-design-category="button_vd"
            data-design-action="Download"
            data-design-label="Download Aftercare Brochure"
            data-design-nori_id="Hero"
            data-design-module_name="what to expect"
            data-design-module_no="01"
            data-qa-tag="download-aftercare-brochure"
            disabled={true}
          >
            Download Aftercare Brochure
            <DownloadIcon /> 
          </Button>
        </div>
      </RichText>
    </div>
  );
};

export default function WhatToExpect() {
  return (
    <Layout head={HEAD} hideBrandFooter data-qa-tag="what-to-expect-page">
      <div className={styles.heroWrapper} data-qa-tag="hero-wrapper">
        <ItemBreakpoint breakpoint={'lg'}>
          <HeroFull image={HERO_BG_IMAGE} data-qa-tag="hero-desktop-image">
            <HeroBannerContent></HeroBannerContent>
          </HeroFull>
          <HeroFull
            image={HERO_BG_IMAGE_MOBILE}
            data-qa-tag="hero-mobile-image"
          >
            <HeroBannerContent></HeroBannerContent>
          </HeroFull>
        </ItemBreakpoint>
      </div>
      <section
        className={styles.accordionContainer}
        data-qa-tag="accordion-container"
      >
        <QuestionWrapper
          title={'What to expect after insertion?'}
          question={FAQ_WTE_INSERTION_1}
          content={null}
          moduleNumber="02"
          data-design-visible="visible_vd"
          data-design-type="module"
          data-design-module_name="What to expect after insertion?"
          data-qa-tag="what-to-expect-after-insertion"
        />

        <QuestionWrapper
          title={'Will it affect my period?'}
          background="blue"
          content={WTE_PERIOD[0].content}
          moduleNumber="03"
          data-design-visible="visible_vd"
          data-design-type="module"
          data-design-module_name="Will it affect my period?"
          className="willItAffect"
          data-qa-tag="will-it-affect-my-period"
        />

        <QuestionWrapper
          title={'What other side effects could I experience?'}
          question={WTE_SIDE_EFFECTS}
          size="large"
          titSize="large"
          content={null}
          moduleNumber="04"
          data-design-visible="visible_vd"
          data-design-type="module"
          data-design-module_name="What other side effects could I experience?"
          data-qa-tag="what-other-side-effects"
        />
      </section>
      <div
        className={styles.tableBg}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="When should I call my healthcare professional?"
        data-design-module_no="05"
        data-qa-tag="when-should-i-call-my-healthcare-professional"
      >
        <Container data-qa-tag="call-hcp-container">
          <RichText
            className={styles.tableWrapper}
            data-qa-tag="call-hcp-table-wrapper"
          >
            <div className={styles.title} data-qa-tag="call-hcp-title">
              <h2 data-qa-tag="call-hcp-heading">
                When should I call my healthcare professional?
              </h2>
              <h3 data-qa-tag="call-hcp-subheading">
                Call your healthcare professional immediately if you have…
              </h3>
            </div>
            <AlternativeTable
              content={SE_TABLE_3}
              size="sm"
              title="call your doctor immediately if you have …"
              data-qa-tag="call-hcp-table"
            />
          </RichText>

          <Question
            question={CALL_HCP_QUESTION}
            className="getFree"
            direction="row"
            size="large"
            data-qa-tag="call-hcp-question"
          />
        </Container>
      </div>
    </Layout>
  );
}
